import type { ReactNode } from "react";
import Logo from "@/components/feature/Logo";
import ThemeToggle from "@/components/feature/ThemeToggle";

interface AuthShellProps {
  children: ReactNode;
}

const highlights = [
  { icon: "ri-file-list-3-line", text: "Gestiona las solicitudes de servicio en tiempo real." },
  { icon: "ri-mail-check-line", text: "Avisos automáticos al equipo y confirmación al cliente." },
  { icon: "ri-shield-check-line", text: "Acceso protegido con autenticación segura." },
];

export default function AuthShell({ children }: AuthShellProps) {
  return (
    <div className="flex min-h-screen bg-background-50">
      {/* Panel de marca */}
      <aside className="relative hidden w-1/2 overflow-hidden bg-primary-950 lg:flex lg:flex-col lg:justify-between">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20navy%20blue%20geometric%20logistics%20network%20with%20soft%20light%20streaks%2C%20minimal%20corporate%20technology%20background%2C%20deep%20ocean%20blue%20tones%2C%20elegant%20harmonious%20composition&width=960&height=1280&seq=axonia-admin-auth&orientation=portrait"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/80 via-primary-950/70 to-primary-900/85"></div>

        <div className="relative p-10">
          <Logo light />
        </div>

        <div className="relative px-10">
          <h2 className="max-w-md text-3xl font-heading font-bold text-balance text-primary-50">
            Plataforma de gestión de AXONIA GROUP
          </h2>
          <ul className="mt-8 space-y-4">
            {highlights.map((item) => (
              <li key={item.text} className="flex items-start gap-3 text-sm text-primary-100">
                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-primary-50/10 text-accent-300">
                  <i className={`${item.icon} text-base leading-none`} aria-hidden="true"></i>
                </span>
                {item.text}
              </li>
            ))}
          </ul>
        </div>

        <div className="relative p-10 text-xs text-primary-300">
          © {new Date().getFullYear()} AXONIA GROUP. Uso interno.
        </div>
      </aside>

      {/* Contenido */}
      <main className="flex w-full flex-col lg:w-1/2">
        <div className="flex h-16 items-center justify-between px-5 lg:h-20 lg:justify-end lg:px-10">
          <div className="lg:hidden">
            <Logo />
          </div>
          <ThemeToggle />
        </div>
        <div className="flex flex-1 items-center justify-center px-5 pb-12 lg:px-10">
          <div className="w-full max-w-md">{children}</div>
        </div>
      </main>
    </div>
  );
}